import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import SectionTitle from '../../components/SectionTitle';
import SingleTestimonialThree from '../../components/Testimonial/SingleTestimonialThree';

import testimonialBG from '../../assets/img/testimonial/bg-4.jpg';
import testimonialImg from '../../assets/img/testimonial/thumb-4-1.jpg';
import avatarImg1 from '../../assets/img/testimonial/avatar-5.png';
import avatarImg2 from '../../assets/img/testimonial/avatar-1.png';

const Testimonial = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '1',
    spaceBetween: 30,
    autoplay: false,
    navigation: {
      prevEl: '.slider-prev-2',
      nextEl: '.slider-next-2',
    },
  };

  return (
    <div
      id="it-testimonial"
      className="it-testimonial-2-area it-testimonial-2-ptb p-relative"
    >
      <div className="it-testimonial-2-grey-bg"></div>
      <div className="it-testimonial-2-bg">
        <img src={testimonialBG} alt="" />
      </div>
      <div className="container">
        <div className="it-testimonial-2-wrap p-relative">
          <div className="row">
            <div className="offset-xl-5 offset-lg-5 col-xl-7 col-lg-7">
              <div className="it-testimonial-2-right z-index">
                <SectionTitle
                  itemClass="it-testimonial-2-title-box mb-35"
                  subTitleClass="it-section-subtitle grey"
                  subTitle="Testimonial"
                  titleClass="it-section-title text-white"
                  title="Customers Says"
                />
                <div className="it-testimonial-2-wrapper p-relative">
                  <div className="swiper-container it-testimonial-3-active">
                    <Swiper
                      modules={[Navigation]}
                      {...sliderOption}
                      className="swiper-wrapper"
                    >
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          descriptionClass="text-white p-max-width"
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore eu fugiat nulla`}
                          avatarImage={avatarImg1}
                          authorName="Shophie Laurier"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          descriptionClass="text-white p-max-width"
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore eu fugiat nulla`}
                          avatarImage={avatarImg2}
                          authorName="Patrice Tardif"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                  <div className="it-testimonial-arrow-box text-end">
                    <button className="slider-prev-2">
                      <span>
                        <i className="fa-regular fa-angle-left"></i>
                      </span>
                    </button>
                    <button className="slider-next-2">
                      <span>
                        <i className="fa-regular fa-angle-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="it-testimonial-2-thumb z-index">
            <img src={testimonialImg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
